export default "__VITE_ASSET__7c16f11e__"